module.exports = __webpack_public_path__ + "static/img/unwinning-zh.022898b9.png";